import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivityViewDataService } from './../../shared/services/activity-view-data.service';
import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';

@Injectable()
export class TeacherActivityViewResolverService  {
    constructor(private authService: AuthService,
        private activityViewDataService: ActivityViewDataService,
        private appHelperService: AppHelperService
    ) { }
    
    resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
        const spaceId = route.params.spaceId;
        const productCode = route.params.productCode;
        const classId = route.params.classId;
        const assignmentId = route.params.assignmentid;
        const userData = this.authService.getUserData();
        return this.activityViewDataService.getClassActivityViewDataForTeacher({spaceId, productCode, classId, assignmentId}).toPromise()
        .then((productData: any)=> {
            if (productData && productData.success === false) {
                this.appHelperService.showLoaderAndNavigateToDashboard();
                return;
            }

            // NEMO-6677 : navigate away to dashboard as the product is suppressed.
            let bundleDetails = productData['bundleDetails'];
            let product = bundleDetails && bundleDetails.products && bundleDetails.products.find((bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
            let suppressedLP = this.appHelperService.isProductSuppressed(product, 'hide-learning-path', spaceId);
            if (suppressedLP) {
                this.appHelperService.navigateToDashboardApp([]);
            }

            return {
                'userProfileData': userData,
                'productData': productData
            }
        });
    }
}
